import { render, staticRenderFns } from "./PendenciaHome.vue?vue&type=template&id=40ac1e8c"
import script from "./PendenciaHome.vue?vue&type=script&lang=js"
export * from "./PendenciaHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports